<template>
  <nav class="instructor-navigation">
    <router-link
      to="/instructor/home"
      class="nav-item"
      :class="{ active: $route.path === '/instructor/home' }"
    >
      <span class="nav-icon">🏠</span>
      <span class="nav-label">ホーム</span>
    </router-link>
    
    <router-link
      to="/instructor/history"
      class="nav-item"
      :class="{ active: $route.path === '/instructor/history' }"
    >
      <span class="nav-icon">🔔</span>
      <span class="nav-label">履歴</span>
      <span v-if="unreadCount > 0" class="nav-badge">{{ unreadCount }}</span>
    </router-link>
    
    <router-link
      to="/instructor/mypage"
      class="nav-item"
      :class="{ active: $route.path === '/instructor/mypage' }"
    >
      <span class="nav-icon">👤</span>
      <span class="nav-label">マイページ</span>
    </router-link>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { supabase } from '../../supabaseClient'

const unreadCount = ref(0)

// 未読数を取得（TODO: 実際の未読履歴ロジックに合わせて実装）
const loadUnreadCount = async () => {
  try {
    // TODO: 実際の未読履歴のカウントロジックを実装
    // 現時点では仮の値を設定
    unreadCount.value = 0
  } catch (error) {
    console.error('未読数取得エラー:', error)
  }
}

onMounted(() => {
  loadUnreadCount()
  
  // 定期的に未読数を更新（30秒ごと）
  const refreshInterval = setInterval(() => {
    loadUnreadCount()
  }, 30000)
  
  onUnmounted(() => {
    clearInterval(refreshInterval)
  })
})
</script>

<style scoped>
.instructor-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 2px solid #e5e7eb;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.5rem 0;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom)); /* ノッチ対応 */
  z-index: 1000;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #6b7280;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
  position: relative;
  flex: 1;
  max-width: 120px;
}

.nav-item:hover {
  color: #3b82f6;
  background: #f3f4f6;
  border-radius: 8px;
}

.nav-item.active {
  color: #3b82f6;
  font-weight: 700;
}

.nav-icon {
  font-size: 1.5rem;
}

.nav-label {
  font-size: 0.75rem;
}

.nav-badge {
  position: absolute;
  top: 0;
  right: 0.5rem;
  background: #ef4444;
  color: white;
  border-radius: 10px;
  padding: 0.125rem 0.375rem;
  font-size: 0.7rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* スマホ対応 */
@media (max-width: 768px) {
  .nav-item {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  
  .nav-icon {
    font-size: 1.3rem;
  }
  
  .nav-label {
    font-size: 0.7rem;
  }
}
</style>

